import { useContext, useState } from "react";
import Button from "../../atoms/button";
import LoadingOverlay from "../../atoms/loadingOverlay";
import { deleteSerial } from "../functions";
import ToastContext from "../../../context/toastProvider";
import { getVisibleGradeFields, renderApplicableGradeValue } from "../../utils/serialGradeFields";

const Serial = ({ user, serial, index, refresh, setProductSerials, product }) => {

    const { badToast, goodToast } = useContext(ToastContext);

    const [confirm, setConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const visibleGrades = getVisibleGradeFields(serial, product);

    const doDeleteSerial = async () => {
        if (serial?.new) {
            return setProductSerials(ps => ps.filter(s => s?.rId !== serial?.rId));
        }
        setLoading(true);
        const data = await deleteSerial(user?.token, serial?._id, serial?.isDraft);
        if (data?.type === "success") {
            goodToast("Serial excluído!");
            setLoading(false);
            refresh();
            return null;
        }
        badToast("Erro ao excluir serial");
        setConfirm(false);
        setLoading(false);
    }

    return (
        <div className="border border-primary p-2 bg-black mb-4 relative">
            {
                serial?.isDraft ?
                    <div className="absolute top-2 left-10 bg-green-300 px-2 py-1 text-black">NOVO</div>
                    : null
            }
            {
                user?.roles?.includes("admin") ?
                    <div className="absolute top-2 right-2">
                        {
                            confirm ?
                                <div className="flex gap-4">
                                    <Button classes="bg-red-500 hover:bg-red-300" click={doDeleteSerial}>Excluir</Button>
                                    <Button classes="bg-primary" click={() => setConfirm(false)}>Cancelar</Button>
                                </div>
                                :
                                <Button classes="bg-red-500 hover:bg-red-300" click={() => setConfirm(true)}>Excluir</Button>
                        }
                    </div>
                    : null
            }
            <div className="absolute top-1 left-2">
                <p className="text-[#666] text-sm">{index + 1}</p>
            </div>
            {
                serial?.isDraft ?
                    <h3 className="text-center mb-4 text-green-500 font-bold">Rascunho de serial</h3>
                    :
                    <h3 className="text-center mb-4">Serial: {serial?.serialNumber}</h3>
            }
            <div className="flex justify-center gap-4 flex-wrap">
                <div className="w-28">
                    <p className="m-0 -mb-1 text-sm text-[#999] text-center">Jogo</p>
                    <p className="px-2 text-center break-words" title={serial?.gradableModel?.game}>{serial?.gradableModel?.game}</p>
                </div>
                <div className="w-28">
                    <p className="m-0 -mb-1 text-sm text-[#999] text-center">Nome</p>
                    <p className="px-2 text-center break-words" title={serial?.gradableModel?.name}>{serial?.gradableModel?.name}</p>
                </div>
                <div className="w-28">
                    <p className="m-0 -mb-1 text-sm text-[#999] text-center">Edição</p>
                    <p className="px-2 text-center break-words" title={serial?.gradableModel?.edition}>{serial?.gradableModel?.edition}</p>
                </div>
                <div className="w-28">
                    <p className="m-0 -mb-1 text-sm text-[#999] text-center">Numeração</p>
                    <p className="px-2 text-center break-words" title={serial?.gradableModel?.numbering}>{serial?.gradableModel?.numbering}</p>
                </div>
                <div className="w-28">
                    <p className="m-0 -mb-1 text-sm text-[#999] text-center">Ano</p>
                    <p className="px-2 text-center break-words" title={serial?.gradableModel?.year}>{serial?.gradableModel?.year}</p>
                </div>
                <div className="w-28">
                    <p className="m-0 -mb-1 text-sm text-[#999] text-center">Língua</p>
                    <p className="px-2 text-center break-words" title={serial?.gradableModel?.language}>{serial?.gradableModel?.language}</p>
                </div>
                <div className="w-28">
                    <p className="m-0 -mb-1 text-sm text-[#999] text-center">Raridade</p>
                    <p className="px-2 text-center break-words" title={serial?.gradableModel?.rarity}>{serial?.gradableModel?.rarity}</p>
                </div>
            </div>
            <div className="flex justify-center gap-4 flex-wrap mt-2">
                {
                    visibleGrades.generalScore ?
                        <div className="w-28">
                            <p className="m-0 -mb-1 text-sm text-[#999] text-center">{visibleGrades.generalScore.label}</p>
                            <p className="px-2 text-center truncate text-3xl">{renderApplicableGradeValue(visibleGrades.generalScore.value)}</p>
                        </div>
                        : null
                }
                {
                    visibleGrades.autographNote ?
                        <div className="w-28">
                            <p className="m-0 -mb-1 text-sm text-[#999] text-center">{visibleGrades.autographNote.label}</p>
                            <p className="px-2 text-center truncate text-3xl">{renderApplicableGradeValue(visibleGrades.autographNote.value)}</p>
                        </div>
                        : null
                }
                {
                    visibleGrades.subgrades.map(field => (
                        <div className="w-28" key={field.key}>
                            <p className="m-0 -mb-1 text-sm text-[#999] text-center">{field.label}</p>
                            <p className="px-2 text-center truncate text-3xl">{renderApplicableGradeValue(field.value)}</p>
                        </div>
                    ))
                }
            </div>
            <LoadingOverlay loading={loading} />
        </div>
    )
}

export default Serial;
